import React, {useEffect} from 'react';

import {setWindowTitle} from 'BenchlingUtil';
import getTestProps from 'test/lib/cypress/getTestProps';

export default function AppCanvasBuilder(): JSX.Element | null {
  useEffect(() => {
    setWindowTitle('App Canvas Builder');
  }, []);

  return (
    <div
      className="settingsPage font-proxima-13"
      {...getTestProps({component: 'AppCanvasBuilder', element: 'root'})}
    >
      <div className="settingsPage-contentWrapper">
        <div>App canvas builder</div>
      </div>
    </div>
  );
}
